var alignment_rtlignore_default = {
  "alignLeft": "YxKFr",
  "textWrapNowrap": "koQ1f",
  "alignRight": "c9u6A",
  "alignCenter": "_5cRA3",
  "sizeFullWidth": "BCKlA",
  "renderedInTable": "kKGFP",
  "sizeOriginal": "zKrv2",
  "sizeContent": "f5HFp",
  "sizeSmall": "wyrJY",
  "sizeSmallCenter": "_4RcQp",
  "flex": "C2Crs",
  "LEFT": "HWfiy",
  "CENTER": "trZdW",
  "RIGHT": "XN9wp",
  "AUTO": "MF9o1",
  "JUSTIFY": "gkFSW"
};
export {
  alignment_rtlignore_default as default
};
//# sourceMappingURL=alignment.rtlignore-scss.js.map
